import axios, { CancelToken } from 'axios';
import { getClientEnv, getLoginInfoPromise } from '../utils/common';

// import request from './request';
export interface ResponseType<T> {
    msg: string;
    code: number;
    data: T;
}
interface Resp<T> {
    data: T;
    code: number,
    msg: string;
}
interface ComponentConfigResp {
    type: number;    //0-附近站点，1-所在城市站点，2-指定城市站点
    cityCode: string;    //高德城市编码，当组件为指定城市搜索时该字段有值，如广州市是020
    cityName: string;    //城市名
    searchList: StationComponent[]
}
export interface StationComponent {
    code?: string;  //配置的站点类型，如“xpSelfStation”
    name: string;  //配置的站点类型名，如“小鹏自营站”
    filterCodeList: string[];
    alwaysShow: 0 | 1; //是否常显，0-否，1-是
    fallBackCode: string;  //兜底的站点类型，如“freeStation”
    fallBackName: string;  //兜底的站点类型名，如“免费站”
    fallBackFilterCodeList: string[];
}


interface MapLabelResp {
    result: StationPoint[];
    radius: number;  //查询半径，km
    mapScaleLevel: number;   //比例尺级别，控制前端地图缩放大小
}
interface CountryResp {
    provinceStationLabelingList: StationPoint[];
    cityStationLabelingList: StationPoint[];
    validFilterCriteriaCodeList: string[];   //比例尺级别，控制前端地图缩放大小
}

export interface AggregateStationLabelingVO {
    dimension: number;
    code: string;
    latitude: number;
    longitude: number;
    staitonNum: number;
    selfOperateStationNum: number;
}
export interface StationPoint {
    stationId: string;
    stationName: string;
    longitude: number;
    latitude: number;
    distance: number;
    newStation: boolean;
    showFreeV2: boolean; //是否展示免费角标
    showXpOwner: boolean; //是否展示专享角标
    s4Num: number;
    dcNum: number;
    acNum: number;
    operationMode: number;
    showPreferredPartnership: boolean;
}


interface AggregateCondition {
    aggId?: string;
    filterCodeList: string[]
}
interface StationNumResp {
    result: {
        aggId: string;
        nums: number;
    }[]
}


// 获取配置
export function getH5ComponentConfig(data: { code: string }) {
    let requestObj = request()
    return requestObj.axiosFun<{ code: string }, Resp<ComponentConfigResp>>(
        '/front/charge/station/search/queryH5ComponentConfig',
        data,
        'POST'
    );
}
// 附近站点列表查询
// export function queryMapLabeling(data: { latitude: string | number; longitude: string | number; source: number; }) {
//     return request<{ latitude: string | number; longitude: string | number; source: number; }, MapLabelResp>(
//         '/v5/charge/station/search/queryMapLabeling',
//         data,
//         'POST'
//     );
// }

// 城市站点列表查询
export function queryMapLabeling() {
    let requestObj = request()
    const axiosFun = (data: { latitude: string | number; longitude: string | number; currentLat?: string | number; currentLon?: string | number; source: number; filterCriteriaCodeList?: string[]; uid?: string; }, cancelList) => {
        return requestObj.axiosFun<{ latitude: string | number; longitude: string | number; currentLat?: string | number; currentLon?: string | number; source: number; filterCriteriaCodeList?: string[]; uid?: string; }, Resp<MapLabelResp>>(
            '/front/charge/station/search/queryMapLabeling',
            data,
            'POST',
            cancelList
        );
    }
    const cancel = async (cancelList) => {
        await requestObj.cancel(cancelList, 'cancel queryMapLabeling')
    }
    return {
        axiosFun,
        cancel
    }
}

// 城市站点列表查询
export function queryMapCityLabeling() {
    let requestObj = request()
    const axiosFun = (data: { cityCode: string; currentLat?: string | number; currentLon?: string | number; source: number; filterCriteriaCodeList?: string[]; uid?: string; }, cancelList) => {
        return requestObj.axiosFun<{ cityCode: string; currentLat?: string | number; currentLon?: string | number; source: number; filterCriteriaCodeList?: string[]; uid?: string; }, Resp<MapLabelResp>>(
            '/front/charge/station/search/queryMapCityLabeling',
            data,
            'POST',
            cancelList
        );
    }
    const cancel = async (cancelList) => {
        await requestObj.cancel(cancelList, 'cancel queryMapCityLabeling')
    }
    return {
        axiosFun,
        cancel
    }
}


// 查询全国省市区的站点
export function queryMapAggregateLabeling() {
    let requestObj = request()
    const axiosFun = (data: { source: number; filterCriteriaCodeList?: string[]; uid?: string; }, cancelList) => {
        return requestObj.axiosFun<{ source: number; filterCriteriaCodeList?: string[]; uid?: string; }, Resp<CountryResp>>(
            '/front/charge/station/search/queryMapAggregateLabeling',
            data,
            'POST',
            cancelList
        );
    }
    const cancel = async (cancelList) => {
        await requestObj.cancel(cancelList, 'cancel queryMapAggregateLabeling')
    }
    return {
        axiosFun,
        cancel
    }
}


// 查询城市符合筛选条件的站点数量
export function findCityStationNum(data: { source: number; cityCode: string; aggregateList: AggregateCondition[] }) {
    return request().axiosFun<{ source: number; cityCode: string; aggregateList: AggregateCondition[] }, Resp<StationNumResp>>(
        '/front/charge/station/search/findCityStationNum',
        data,
        'POST'
    );
}
// 查询附近站点符合筛选条件的站点数量
export function findNearByStationNum(data: {
    source: number;
    radius: number;
    longitude: number;
    latitude: number;
    aggregateList: AggregateCondition[]
}) {
    return request().axiosFun<{
        source: number;
        radius: number;
        longitude: number;
        latitude: number;
        aggregateList: AggregateCondition[]
    }, Resp<StationNumResp>>(
        '/front/charge/station/search/findNearByStationNum',
        data,
        'POST'
    );
}
interface NearByStationResp {
    sortStrategyId: number;
    result: NearByStationVO[];
}
export interface NearByStationVO {
    stationId: number;
    stationName: string;
    stationAddr: string;
    longitude: number;
    latitude: number;
    distance: number;
    operationMode: number;
    stationAvailabilityDesc: string;
    stationLabelList: { labelCode: string; labelName: string }[];
}
// 附近站点列表查询
export function findNearByStationV2(data: { pageSize: number, source: number; radius: number; sortType: number; filterCriteriaCodeList: string[]; latitude?: number | string; longitude?: string | number; cityCode?: string; currentLon: string | number; currentLat: string | number; }) {
    return request().axiosFun<{ pageSize: number, source: number; radius: number; sortType: number; filterCriteriaCodeList: string[]; latitude?: number | string; longitude?: string | number; cityCode?: string; currentLon: string | number; currentLat: string | number; }, Resp<NearByStationResp>>(
        '/front/charge/station/search/findNearByStationV2',
        data,
        'POST'
    );
}

// 附近站点列表查询
export function findCityStation(data: { pageSize: number, source: number; cityCode: string; filterCriteriaCodeList: string[]; latitude?: number | string; longitude?: string | number; sortType: number; uid?: string }) {
    return request().axiosFun<{ pageSize: number, source: number; cityCode: string; filterCriteriaCodeList: string[]; latitude?: number | string; longitude?: string | number; sortType: number; uid?: string }, Resp<NearByStationResp>>(
        '/front/charge/station/search/findCityStation',
        data,
        'POST'
    );
}



export enum StationStatusEnum {
    ON = '1',
    OFF = '0',
    WAIT = '2'
}
export interface QueryStationDtlResp {
    // 0非自营 1自营
    selfSupportFlag: string;
    stationId: string;
    stationName: string;
    stationAddr: string;
    //0正常 1加盟 2合作
    stationCooperationType: number;
    distance: string;
    // 充电费单价
    chargeAmt: string;
    // 服务费单价
    serviceAmt: string;
    payment: string;
    // 快充数量
    dcNums: number;
    dcFreeNums: number;
    // 慢充数量
    acNums: number;
    acFreeNums: number;
    openFlag: StationStatusEnum;
    // 专享
    allXpPile: boolean;
    // 免费
    freeStation: boolean;
    operationMode: number; // 自营站场站类型判断条件调整 1: 自营, 2: 加盟, 3: 合作, 0: 普通（其他）

    // 新增专享
    showXpOwner: boolean;
    // 新增免费
    showFree: boolean;
    // 气泡样式枚举，buildingXp-灰色小鹏logo气泡，xp-小鹏logo的气泡，lighting-闪电
    bubbleIconType: "buildingXp" | "xp" | "lighting";
    // 超快充数量
    s4Nums: number;
    // 超快充空闲数量
    s4FreeNums: number;
}

// 官网地图：查询站点详细信息
export function queryStationDtl(data: { stationId: string; }) {
    return request().axiosFun<{ stationId: string; }, Resp<QueryStationDtlResp>>(
        '/front/charge/free/station/queryStationDtl',
        data,
        'POST'
    );
}

















let apiDomain = '';
if (window.location.href.indexOf('static.deploy-test.xiaopeng.com') !== -1) {
    apiDomain = 'https://chargegateway.deploy-test.xiaopeng.com';
} else if (window.location.href.indexOf('static.xiaopeng.com') !== -1) {
    apiDomain = 'https://chargegateway.xiaopeng.com';
} else {
    apiDomain = 'https://chargegateway.deploy-test.xiaopeng.com';
}
function request() {
    function axiosFun<T, P>(url, params?: T, method = 'GET', cancelList?): Promise<P> {
        return new Promise((resolve, reject): void => {
            method = method.toUpperCase();
            axios({
                url: apiDomain + url,
                data: method !== 'GET' ? params : {},
                params: method === 'GET' ? params : {},
                method: method as any,
                cancelToken: new axios.CancelToken(c => (cancelList && cancelList.push(c)))

            }).then(response => {
                resolve(response.data);
            }).catch((err) => {
                reject(err);
            });
        });
    }
    const cancel = (cancelList, msg) => {
        return new Promise((resolve) => {
            while (cancelList && cancelList.length > 0) {
                cancelList.pop()(msg)
            }
            resolve('cancel')
        })
    }
    return {
        cancel,
        axiosFun
    }
}
